import { c as _c } from "react/compiler-runtime";
import { useQueryClient } from "@tanstack/react-query";
import { useState } from "react";
import { Photo } from "react-photo-album";
import { usePhotoAlbum } from "../hooks/use-photo-album";
import { DeletePhotos } from "./modal/photos/delete-photos";
import { PhotoUploader } from "./photo-uploader";
interface PhotoHandlerProps {
  club: {
    displayName: string;
    slug: string;
  };
  setIsEditing: (isEditing: boolean) => void;
}
export const PhotoHandler = t0 => {
  const $ = _c(8);
  const {
    club,
    setIsEditing
  } = t0;
  const [isDeletePending, setIsDeletePending] = useState(false);
  const [photoToDelete, setPhotoToDelete] = useState(null);
  useQueryClient();
  const {
    data: t1
  } = usePhotoAlbum(club);
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const photos = t2;
  let t3;
  if ($[2] !== club || $[3] !== isDeletePending || $[4] !== photoToDelete || $[5] !== photos || $[6] !== setIsEditing) {
    t3 = <>{isDeletePending ? <DeletePhotos clubSlug={club.slug} photo={photoToDelete} setIsDeletePending={setIsDeletePending} setPhotoToDelete={setPhotoToDelete} /> : <div className="text-center"><h1 className="text-3xl font-bold">Photos du club</h1><div className="flex flex-wrap justify-around gap-4 p-5 w-full" style={{
          backgroundColor: "#fefaf5",
          width: "600px",
          margin: "20px auto"
        }}>{photos?.map((photo, index) => <PhotoUploader photoNumber={index + 1} disabled={false} photo={photo} key={photo.src} isEmpty={false} club={club} setIsEditing={setIsEditing} setIsDeletePending={setIsDeletePending} setPhotoToDelete={setPhotoToDelete} />)}{photos?.length < 6 && Array.from({
            length: 6 - photos?.length
          }).map((_, index_0) => <PhotoUploader photoNumber={photos?.length + index_0 + 1} disabled={!(index_0 === 0)} key={`empty-photo-${index_0}`} isEmpty={true} club={club} setIsDeletePending={setIsDeletePending} setPhotoToDelete={setPhotoToDelete} setIsEditing={setIsEditing} />)}</div></div>}</>;
    $[2] = club;
    $[3] = isDeletePending;
    $[4] = photoToDelete;
    $[5] = photos;
    $[6] = setIsEditing;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};